import { ecorEnv } from '@/../environments/environment';
import { SurveyCard } from '@/surveys/states/surveys/survey-card';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class FilingStatusDialogHttpService {
    constructor(private httpClient: HttpClient) { }

    getFilingStatusReport(survey: SurveyCard, format: any, sortParameters: any) {
        const params = new HttpParams()
            .set('surveyInstanceId', survey.surveyInstanceId.toString())
            .set('surveyName', survey.displayName)
            .set('fileType', format)
            .set('sort', sortParameters.property && sortParameters.direction ? sortParameters.property + ',' + sortParameters.direction : '');
        const getFilingStatusReportUrl = ecorEnv.apiEndpoint + '/secure/reports/filingStatus';
        return this.httpClient.get<any>(getFilingStatusReportUrl, { params: params, responseType: 'blob' as 'json' })
            .pipe(
                catchError(this.handleError)
            );
    }

    findAllSurveyForms(surveyId: number, surveyInstanceId: number, sort: any): Observable<any> {
        const params = new HttpParams()
            .set('size', sort.size.toString())
            .set('page', sort.page)
            .set('sort', sort.property + ',' + sort.direction);
        const httpOptions = {
            params: params
        };
        const findAllSurveyFormsUrl = ecorEnv.apiEndpoint + '/secure/surveyForms?surveyInstanceId=' + surveyInstanceId;
        return this.httpClient.get<any>(findAllSurveyFormsUrl, httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getTotalReceived(surveyInstanceId: number): Observable<any> {
        const getTotalReceivedUrl = ecorEnv.apiEndpoint + '/secure/surveyForms/totalReceived?surveyInstanceId=' + surveyInstanceId;
        return this.httpClient.get<any>(getTotalReceivedUrl)
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('surveys', 'error', error);
        if (error.error instanceof ErrorEvent) {
            console.error('surveys', 'client side error:', error.error.message);
        } else {
            return throwError('Error-111111');
        }
        return throwError('Error-222222');
    }
}
